export default {
    BusinessAfterCsgReturn: {
        main: {
            outRefundNo: '退货单号',
            returnOrderDate: '退货时间',
            totalQty: '总数量',
            orderStatus: '订单状态',
            backInventoryQty: '退货数量',
            backInventoryRemark: '退货备注',
            damagedQty: '损坏数量',
            damagedRemark: '损坏备注',
            comment: '备注',
            thirdOrder: '第三方平台订单号',
        },

        table: {
            add: '添加退货产品',
            cusName: '客户',
            reference: '关联信息',
            checkCounts: 'Check Counts',
            skuStatus: '商品状态',
            backInventoryQty: '退回库存数量',
            backInventoryRemark: '退回库存备注',
            damagedQty: '损坏数量',
            damagedRemark: '损坏备注'
        },

        uploadHindText1: '注意',
        uploadHindText2: '至少上传3张图片',
        barCodeText: '请输入BarCode',
        hintMessageText1: '请先选择客户',
        hintMessageText2: '请添加退货商品',
        hintMessageText3: '请上传至少3张图片',
        hintMessageText4: '请完善退货商品信息',
        damageTitleText: '受损订单结果',
        pictureMsg: '图片信息',
        hintMessageText5: '总数量 = 退货数量 + 损坏数量，请认真填写！',
        information: '关联信息',
        imgTip: '必须上传3张照片'
    }
};
